import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, signal } from '@angular/core';
import { Hero } from './hero/hero';
import { OfferProduct } from '../../shared/models/offer-product.model';
import { CarouselComponent } from '../../shared/components/carousel/carousel.component';
import { ProductService } from '../../shared/services/product.service';

@Component({
  selector: 'app-main',
  imports: [CommonModule, Hero, CarouselComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './main.html',
  styleUrl: './main.scss'
})
export class Main {

  private readonly productService = inject(ProductService);
  popularProducts = signal<OfferProduct[]>([]);
  productsOnSale = signal<OfferProduct[]>([]);
  lastVisitedProducts = signal<OfferProduct[]>([]);
  bestDealsProducts = signal<OfferProduct[]>([]);

  constructor() {
    this.loadPopularProducts();
    this.loadProductsOnSale();
    this.loadLastVisitedProducts();
    this.loadBestDealsProducts();
  }

  loadPopularProducts() {
    this.productService.getPopularProducts().subscribe(
      (products) => {
        this.popularProducts.set(products)
        console.log('Popular products loaded:', products);
      }
    );
  }

  loadProductsOnSale() {
    //TODO load products on sale
    // This method can be implemented similarly to loadPopularProducts
    this.productService.getPopularProducts().subscribe(
      (products) => 
        this.productsOnSale.set(products)
    );
  }

  loadLastVisitedProducts() {
    //TODO load last visited products
    // This method can be implemented similarly to loadPopularProducts
    this.productService.getPopularProducts().subscribe(
      (products) => 
        this.lastVisitedProducts.set(products)
    );
  }

  loadBestDealsProducts() {
    //TODO load best deals products
    // This method can be implemented similarly to loadPopularProducts
    this.productService.getPopularProducts().subscribe(
      (products) => 
        this.bestDealsProducts.set(products)
    );
  }
}
